import { isDefaultTopSlot } from "./isDefaultTopSlot";

export function isNotForDefaultTopSlotOrEmpty(
  event: googletag.events.SlotRenderEndedEvent,
): boolean {
  return event.isEmpty || !isDefaultTopSlot(event);
}
